import dayjs, { Dayjs } from "dayjs"
import { DateTimeValidationError } from "@mui/x-date-pickers"

export const toSecondPrecision = (value: dayjs.ConfigType): Dayjs =>
	dayjs(value).millisecond(0)

export const clampStartTime = (value: Dayjs, min: Dayjs, max: Dayjs): Dayjs => {
	if (value.isBefore(min)) {
		return min
	}

	if (value.isAfter(max)) {
		return max
	}

	return value
}

export const describeFieldError = (error: DateTimeValidationError): string => {
	switch (error) {
		case "maxTime":
		case "maxDate":
			return "Time exceeds the end of the recording"

		case "minTime":
		case "minDate":
			return "Time is before the start of the recording"

		case "invalidDate":
			return "The specified date is invalid"

		default:
			return ""
	}
}
